import { apiFetch } from '../../services/http';

export interface MessageTemplate {
  id: string;
  name: string;
  category: 'MARKETING' | 'UTILITY' | 'AUTHENTICATION';
  language: string;
  body: string;
  variables: any;
  status: 'APPROVED' | 'PENDING' | 'REJECTED';
  meta_template_id?: string | null;
  isRemoteOnly?: boolean;
  created_at: string;
}

export interface AiTemplateGenerationResult {
  success: boolean;
  template: {
    name: string;
    category: 'MARKETING' | 'UTILITY' | 'AUTHENTICATION';
    body: string;
    variables: string[];
    explanation?: string;
    language: string;
  };
}

export const templatesApi = {
  list: (init?: RequestInit) => apiFetch<{ items: MessageTemplate[] }>('/v1/crm/templates', init),
  create: (data: Partial<MessageTemplate>, init?: RequestInit) => apiFetch<MessageTemplate>('/v1/crm/templates', {
    ...init,
    method: 'POST',
    body: JSON.stringify(data),
  }),
  delete: (id: string, init?: RequestInit) => apiFetch<{ success: boolean }>(`/v1/crm/templates/${id}`, {
    ...init,
    method: 'DELETE',
  }),
  generateWithAi: (params: { objective?: string; businessNiche?: string; tone?: string; category?: string }, init?: RequestInit) =>
    apiFetch<AiTemplateGenerationResult>('/v1/crm/templates/ai-generate', {
      ...init,
      method: 'POST',
      body: JSON.stringify(params),
    }),
};

